import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Banner from "../ComponentsHome/Banner";
import SolvedSection from "../ComponentsHome/SolvedSection";
import FindDoctorSection from "../ComponentsHome/FindDoctorSection";
import AreYouDoctorSection from "../ComponentsHome/AreYouDoctorSection";
import MeetOurExpert from "../ComponentsHome/MeetOurExpert";
import GetAppSec from "../ComponentsHome/GetAppSec";
import BlogSection from "../ComponentsHome/BlogSection";

const Home = () => {
	return (
		<>
			<Header />
			<Banner />
			<SolvedSection />
			<AreYouDoctorSection />
			<MeetOurExpert />
			<GetAppSec />
			<Footer />
		</>
	);
};

export default Home;
